<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div>

    <v-dialog v-model="dialog" max-width="500px">
      <v-card>
        <v-card-title>
          <span class="headline">Edit</span>
        </v-card-title>

        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12 sm6 md4>
                <v-combobox v-model="editedItem.manufacturer" label="Manufacturer" :items="manufacturers" item-text="name" item-value="name"></v-combobox>
              </v-flex>
              <v-flex xs12 sm6 md4>
                <v-text-field v-model="editedItem.model" label="Model"></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md4>
                <v-text-field v-model="editedItem.weight" label="Weight"></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md4>
                <v-text-field v-model="editedItem.diameter" label="Diameter"></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md4>
                <v-checkbox v-model="editedItem.confirmed" label="Confirmed"></v-checkbox>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn :loading="loading" color="blue darken-1" flat @click="close">Cancel</v-btn>
          <v-btn :loading="loading" color="blue darken-1" flat @click="saveRime">Save</v-btn>
          <v-btn :loading="loading" color="blue darken-1" flat @click="saveRime(false)" v-if="editedIndex == -1">Save & next</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-btn @click="editItem">Add New</v-btn>

    <v-data-table
      :headers="headers"
      :items="rims"
      :rows-per-page-items="rowsPerPage"
      class="elevation-1"
    >
      <template v-slot:items="props">
        <td class="text-xs-right">{{ props.item.manufacturer.name }}</td>
        <td class="text-xs-left">{{ props.item.model }}</td>
        <td class="text-xs-center">{{ props.item.weight }}</td>
        <td class="text-xs-center">{{ props.item.diameter }}</td>
        <td class="text-xs-center">{{ props.item.confirmed ? 'Coool' : 'no' }}</td>
        <td class="">
          <v-icon
            small
            @click="editItem(props.item)"
          >
            edit
          </v-icon>
          <v-icon
            small
            @click="deleteItem(props.item)"
          >
            delete
          </v-icon>
        </td>
      </template>
      <template v-slot:no-data>
        <v-btn color="primary" @click="fetchData">Reload</v-btn>
      </template>
    </v-data-table>
  </div>
</template>

<script>
  import StringMixinx from '../mixins/StringMixin'
  import {eventBus} from '../main';

  export default {
    mixins: [StringMixinx],
    name: 'RimsAdmin',
    created() {
      eventBus.$emit('title-change', 'Admin - Rims');

      this.fetchData();
    },
    data() {
      return {
        dialog: false,
        manufacturers: [],
        headers: [
          {
            text: 'Manufacturer', value: 'manufacturer.name', class: 'manu'
          },
          {
            text: 'Model', value: 'model', class: 'model'
          },
          {
            text: 'Weight', value: 'weight', class: 'small-col'
          },
          {
            text: 'Diameter', value: 'diameter', class: 'small-col'
          },
          {
            text: 'Confirmed', value: 'confirmed', class: 'small-col'
          },
          {text: 'Actions', value: 'name', sortable: false}],
        rims: [],
        editedItem: {},
        rowsPerPage: [20, 50, 100, 500, 1000],
        loading: false,
        editedIndex: 0
      }
    },
    methods: {
      //'8d1dfe9c-78b8-4a44-bbc3-5a316f751ac2-62684042-2b11-4996-828b-683d89cc1604-8f4eeba7-c23f-4930-8695-b8e3e59257fd'
      fetchData() {
        fetch('https://be.mybikesetup.net/wheels/admin/rims', {
          headers: {
            'Content-Type': 'application/json',
            'XYZ-Admin-Token': this.$store.state.apiKey
          }
        }).then(response => response.ok ? response.json() : alert('mist')).then(json => {
          if (json != null) {
            this.rims = json.rims;
          }
        });
        // fetch('https://be.mybikesetup.net/wheels/admin/rims', {
        //   headers: {
        //     'Content-Type': 'application/json',
        //     'XYZ-Admin-Token': '8d1dfe9c-78b8-4a44-bbc3-5a316f751ac2-62684042-2b11-4996-828b-683d89cc1604-8f4eeba7-c23f-4930-8695-b8e3e59257fd'
        //   }
        // }).then(response => response.ok ? response.json() : alert('mist')).then(json => {
        //   if (json != null) {
        //     this.rims = json.rims;
        //   }
        // });
      },
      editItem(item) {
        fetch('https://be.mybikesetup.net/wheels/admin/manufacturers', {
          headers: {
            'XYZ-Admin-Token': this.$store.state.apiKey
          }
        }).then(response => response.ok ? response.json() : alert('mist')).then(json => {
          this.hubManufacturers = json || {};
        });
        this.editedIndex = this.rims.indexOf(item);
        this.editedItem = Object.assign({}, item);
        this.dialog = true
      },

      deleteItem(item) {
        const index = this.rims.indexOf(item)
        confirm('Are you sure you want to delete this item?') &&
        fetch('https://be.mybikesetup.net/wheels/admin/rims/' + item.id, {
          method: 'DELETE',
          headers: {
            'Content-Type': 'application/json',
            'XYZ-Admin-Token': this.$store.state.apiKey
          }
        }).then(response => response.ok ? this.rims.splice(index, 1) : alert('mist'))
      },

      saveRime(next) {
        if (this.editedItem.manufacturer.name) {
          this.editedItem.manufacturer = this.editedItem.manufacturer.name;
        }
        this.loading = true;
        fetch('https://be.mybikesetup.net/wheels/admin/rims/' + (this.editedItem.id == null ? '' : this.editedItem.id), {
          method: this.editedItem.id == null ? 'PUT' : 'POST',
          body: JSON.stringify(this.editedItem),
          headers: {
            'Content-Type': 'application/json',
            'XYZ-Admin-Token': this.$store.state.apiKey
          }
        }).then(response => response.ok ? response.json() : alert('mist')).then(json => {
          if (json != null) {
            if (this.editedIndex != -1) {
              Object.assign(this.hubs[this.editedIndex], json);
            } else {
              this.fetchData();
            }
            this.dialog = false;
            if (next != false) {
              this.dialog = false;
            }
          }
          this.loading = false;
        });
      },
      close() {
        this.dialog = false;
      }
    }
  }
</script>

<style>
  .manu {
    min-width: 150px;
  }

  .model {
    min-width: 300px;
  }

  .small-col {
    max-width: 70px;
  }
</style>



// WEBPACK FOOTER //
// src/views/RimsAdmin.vue